import { Breadcrumbs } from '../components/Breadcrumbs';
import { Reveal } from '../components/Reveal';
import { business } from '../content/site';

export function Privacy() {
  return (
    <article className="legal-page section-shell">
      <Breadcrumbs items={[{ label: 'Privacy' }]} />
      <Reveal><h1>Privacy</h1><p className="legal-page__intro">This notice explains how project inquiry information is used.</p></Reveal>
      <Reveal as="section"><h2>Information you provide</h2><p>The inquiry form can collect your name, contact details, property location, preferred contact method, project type, timing, and description.</p></Reveal>
      <Reveal as="section"><h2>How it is used</h2><p>The information is used to review your request, contact you about the project, and keep an operational record of the inquiry. It is not intended for sale to unrelated marketers.</p></Reveal>
      <Reveal as="section"><h2>Delivery and storage</h2><p>When online delivery is configured, form data is sent to a WadeMedia-operated lead endpoint for storage and notification. If delivery is unavailable, the site offers direct phone and email options without claiming that the form was sent.</p></Reveal>
      <Reveal as="section"><h2>Your choices</h2><p>You can contact Vic’s Bricks directly instead of using the form. To ask about an inquiry, email <a href={business.emailHref}>{business.email}</a> or call <a href={business.phoneHref}>{business.phoneDisplay}</a>.</p></Reveal>
    </article>
  );
}

